class AeroTermsOfSale {
  constructor() {
    this.checkoutButton = document.querySelector('#main-cart-footer button[name="checkout"]');
    this.dynamicCheckoutButtons = document.querySelector('#main-cart-footer .cart__dynamic-checkout-buttons');
    this.termsCheckbox = document.querySelector('#main-cart-footer #terms-checkbox');
    this.termsTooltip = document.querySelector('#main-cart-footer #terms-tooltip');
    this.termsModal = document.querySelector('#main-cart-footer #terms-modal');
    this.termsModalOkButton = document.querySelector('#main-cart-footer #terms-modal-ok');
    this.cartForm = document.querySelector('#cart');
    
    if (this.checkoutButton && this.termsCheckbox) {
      this.init();
    }
  }

  init() {
    // Disable checkout buttons initially
    this.disableCheckoutButtons();
    
    // Add event listeners
    this.termsCheckbox.addEventListener('change', () => this.handleCheckboxChange());
    this.checkoutButton.addEventListener('click', (e) => this.handleCheckoutClick(e));
    
    // Prevent form submission if terms not accepted
    if (this.cartForm) {
      this.cartForm.addEventListener('submit', (e) => {
        if (!this.termsCheckbox.checked) {
          e.preventDefault();
          this.showModal();
        }
      });
    }
    
    // Setup dynamic checkout buttons
    if (this.dynamicCheckoutButtons) {
      // Handle click on the container
      this.dynamicCheckoutButtons.addEventListener('click', (e) => {
        if (!this.termsCheckbox.checked) {
          e.preventDefault();
          e.stopPropagation();
          this.showModal();
        }
      }, true); // Use capture phase to catch events before they reach the buttons

      // Handle hover events on the container
      this.dynamicCheckoutButtons.addEventListener('mouseenter', () => {
        if (!this.termsCheckbox.checked) {
          this.showTooltip();
        }
      });

      this.dynamicCheckoutButtons.addEventListener('mouseleave', () => {
        this.hideTooltip();
      });

      // Setup mutation observer for dynamic content
      this.setupMutationObserver();
    }
    
    // Add hover event listeners for main checkout button
    this.checkoutButton.addEventListener('mouseenter', () => {
      if (!this.termsCheckbox.checked) {
        this.showTooltip();
      }
    });
    this.checkoutButton.addEventListener('mouseleave', () => this.hideTooltip());

    // Modal event listener
    this.termsModalOkButton.addEventListener('click', () => this.hideModal());
  }

  setupMutationObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          // If new nodes are added, ensure they're properly disabled if terms aren't accepted
          if (!this.termsCheckbox.checked) {
            this.disableCheckoutButtons();
          }
        }
      });
    });

    observer.observe(this.dynamicCheckoutButtons, {
      childList: true,
      subtree: true,
      attributes: true
    });
  }

  handleCheckboxChange() {
    if (this.termsCheckbox.checked) {
      this.enableCheckoutButtons();
      this.hideTooltip();
    } else {
      this.disableCheckoutButtons();
    }
  }

  handleCheckoutClick(e) {
    if (!this.termsCheckbox.checked) {
      e.preventDefault();
      e.stopPropagation();
      this.showModal();
    }
  }

  showTooltip() {
    if (!this.termsCheckbox.checked) {
      this.termsTooltip.style.display = 'block';
    }
  }

  hideTooltip() {
    this.termsTooltip.style.display = 'none';
  }

  showModal() {
    this.termsModal.style.display = 'flex';
  }

  hideModal() {
    this.termsModal.style.display = 'none';
  }

  disableCheckoutButtons() {
    if (this.checkoutButton) {
      this.checkoutButton.disabled = true;
      this.checkoutButton.setAttribute('aria-disabled', 'true');
    }
    if (this.dynamicCheckoutButtons) {
      this.dynamicCheckoutButtons.style.pointerEvents = 'none';
      this.dynamicCheckoutButtons.style.opacity = '0.5';
    }
  }

  enableCheckoutButtons() {
    if (this.checkoutButton) {
      this.checkoutButton.disabled = false;
      this.checkoutButton.removeAttribute('aria-disabled');
    }
    if (this.dynamicCheckoutButtons) {
      this.dynamicCheckoutButtons.style.pointerEvents = 'auto';
      this.dynamicCheckoutButtons.style.opacity = '1';
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new AeroTermsOfSale();
}); 